import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] ${light ? "text-[#bfe3bf]" : "text-[var(--leaf)]"}`}>
    <span className={`h-px w-8 ${light ? "bg-[#bfe3bf]" : "bg-[var(--leaf)]"}`} />
    {children}
  </p>
);

export const LeafIcon = ({ className = "", fill = "currentColor", style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} aria-hidden="true">
    <path d="M12 1.5C6.2 5.6 4.3 11.4 6.1 17.2 7.4 20.6 10 22.5 12 22.5s4.6-1.9 5.9-5.3C19.7 11.4 17.8 5.6 12 1.5Z" fill={fill} />
    <path d="M12 4v18M12 10l-3-2.5M12 14l3.4-3M12 18l-3.6-3" stroke="#fff" strokeOpacity=".45" strokeWidth="1" fill="none" strokeLinecap="round" />
  </svg>
);
